import { ScrollableList } from '@ps/isp-web-component-library';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import type { SportsHomePageWidgetModel } from 'widgets/sports-home-page-widget/model';
import type { ExtractSelectFromModel, RootState } from '@swf/core/store';
import { ExpandablePanel, SportsComponent, Title } from '@swf/sports/components';
import { isGreyhoundRacing, isHorseRacing } from '@swf/sports/utils/isEventTypeId';

import { TXTWCL_Popular_Sports } from './PopularSportsPicker.messages.json';
import styles from './PopularSportsPicker.modules.scss';
import { PopularSportsPickerItem } from './components/PopularSportsPickerItem';

interface Props {
  widgetSelect: Pick<
    ExtractSelectFromModel<SportsHomePageWidgetModel>,
    'hasPopularSports' | 'popularSports'
  >;
}

export const PopularSportsPicker: React.FC<Props> = ({ widgetSelect }) => {
  const hasPopularSports = useSelector((state: RootState) => widgetSelect.hasPopularSports(state));
  const popularSports = useSelector((state: RootState) => widgetSelect.popularSports(state));
  const isHorseRacingEnabled = useFeature(FeatureFlag.HorseRacingEnabled);
  const isGreyhoundsEnabled = useFeature(FeatureFlag.GreyhoundRacingEnabled);

  if (!hasPopularSports) return null;

  return (
    <div className={styles.panel}>
      <SportsComponent name="Sports Popular Sports Picker Component">
        <ExpandablePanel
          title={
            <Title isNested>
              <Translation {...TXTWCL_Popular_Sports} />
            </Title>
          }
          isNested
        >
          <ScrollableList as="nav" variant="disc-container">
            {popularSports
              .filter(({ eventTypeId }) => {
                if (isHorseRacing(eventTypeId) && !isHorseRacingEnabled) return false;
                if (isGreyhoundRacing(eventTypeId) && !isGreyhoundsEnabled) return false;
                return true;
              })
              .map((popularSport) => (
                <PopularSportsPickerItem key={popularSport.text} popularSport={popularSport} />
              ))}
          </ScrollableList>
        </ExpandablePanel>
      </SportsComponent>
    </div>
  );
};
